/**
 * Marker grammar for the entity-noun catalogue (issue 988).
 *
 * <p>Single source of truth for the `[[content]]` token shape used by:
 * <ul>
 *   <li>{@link entityNounMarkupPostProcessor} (renders markers in i18next strings),
 *   <li>{@link resolveLabelReferences} (resolves cross-references inside catalogue
 *       labels themselves — 988.04),
 *   <li>the build-time coverage gate in
 *       {@code frontend/src/locales/entity-noun-markup-coverage.test.ts}.
 * </ul>
 *
 * <p>The grammar matches `[[content]]` where {@code content} is anything that
 * isn't a closing bracket. Case inside the brackets drives rendered case
 * (see {@link applyCase}); the {@code content} string is the lookup key
 * against the bridge index (lower-cased).
 */

const MARKER_REGEX_SOURCE = '\\[\\[([^\\]]+)\\]\\]'
const GLOBAL_FLAG = 'g'

export function createMarkerRegex(): RegExp {
    return new RegExp(MARKER_REGEX_SOURCE, GLOBAL_FLAG)
}

/** Returns the list of marker `content` strings found in `value`, in document order. */
export function findMarkerContents(value: string): string[] {
    const out: string[] = []
    for (const m of value.matchAll(createMarkerRegex())) {
        out.push(m[1])
    }
    return out
}
